// frontend/admin-portal/src/services/axiosConfig.js
import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_AUTH_API || 'http://localhost:5001/api',
    timeout: 15000,
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (res) => res,
    async (err) => {
        const original = err.config;
        const status = err.response?.status;
        const method = (err.config?.method || 'GET').toUpperCase();
        const url = err.config?.url || '';
        const body = err.response?.data;

        // Log every failed API call with the real server message
        if (status >= 500) {
            console.error(`[API] ${method} ${url} → ${status}`, {
                message: body?.message || err.message,
                response: body,
                payload: err.config?.data,
            });
        } else if (status >= 400) {
            console.warn(`[API] ${method} ${url} → ${status}`, body);
        }


        if (err.response?.status === 401 && !original._retry) {
            original._retry = true;
            const refreshToken = localStorage.getItem('refreshToken');
            if (refreshToken) {
                try {
                    const { data } = await axios.post(
                        `${api.defaults.baseURL}/auth/refresh`,
                        { refreshToken }
                    );
                    localStorage.setItem('accessToken', data.data.accessToken);
                    original.headers.Authorization = `Bearer ${data.data.accessToken}`;
                    return api(original);
                } catch {
                    localStorage.clear();
                    window.location.href = '/login';
                }
            } else {
                localStorage.clear();
                window.location.href = '/login';
            }
        }
        return Promise.reject(err);
    }
);

export default api;